import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  IDebitAccountsBody,
  IDebitAccountsResponse,
} from '../models/debitAccounts.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DebitAccountsService {
  private apiUrl = `${environment.urlServices}/risk-engine/getCuentasAhorro`;

  constructor(private http: HttpClient) {}

  getDebitAccounts(
    data: IDebitAccountsBody
  ): Observable<IDebitAccountsResponse> {
    return this.http.post<IDebitAccountsResponse>(this.apiUrl, data);
  }
}
